"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceReducer = exports.ActionTypes = exports.initialState = void 0;
const workspace_utils_1 = require("./workspace.utils");
exports.initialState = {
    navigation: [],
    status: 'loading',
    folders: [],
    assets: [],
    groups: [],
    search: {
        term: '',
        assets: [],
    },
    assetsLoadLimit: 20,
};
/**
 * Actions
 */
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["ROOT_FOLDER_LOADED"] = "ROOT_FOLDER_LOADED";
    ActionTypes["FOLDER_LOADED"] = "FOLDER_LOADED";
    ActionTypes["UPDATE_FOLDER"] = "UPDATE_FOLDER";
    ActionTypes["PARENT_FOLDER_LOADED"] = "PARENT_FOLDER_LOADED";
    ActionTypes["STATUS_UPDATED"] = "STATUS_UPDATED";
    ActionTypes["SEARCH_LOADED"] = "SEARCH_LOADED";
    ActionTypes["ASSETS_ADDED"] = "ASSETS_ADDED";
    ActionTypes["FOLDER_CREATED"] = "FOLDER_CREATED";
    ActionTypes["GROUP_LOADED"] = "GROUP_LOADED";
})(ActionTypes || (exports.ActionTypes = ActionTypes = {}));
/**
 * Reducer
 */
function workspaceReducer(state, action) {
    switch (action.type) {
        case ActionTypes.ROOT_FOLDER_LOADED:
            return Object.assign(Object.assign({}, state), { folders: action.payload.folders, assets: action.payload.assets, status: 'idle' });
        case ActionTypes.FOLDER_LOADED:
            return Object.assign(Object.assign({}, state), { navigation: Array.from(new Set(state.navigation.concat(action.payload.folderId))), folders: (0, workspace_utils_1.includeResourcesOnFolder)(state, action.payload), status: 'idle' });
        case ActionTypes.UPDATE_FOLDER:
            return Object.assign(Object.assign(Object.assign({}, state), (0, workspace_utils_1.loadMoreAssetsAndSubFoldersToFolder)(state, action.payload)), { status: 'idle' });
        case ActionTypes.ASSETS_ADDED:
            return Object.assign(Object.assign(Object.assign({}, state), (0, workspace_utils_1.appendAssetsToFolder)(state, action.payload)), { status: 'idle' });
        case ActionTypes.FOLDER_CREATED:
            return Object.assign(Object.assign(Object.assign({}, state), (0, workspace_utils_1.appendNewFolderToParent)(state, action.payload)), { status: 'idle' });
        case ActionTypes.PARENT_FOLDER_LOADED:
            return Object.assign(Object.assign({}, state), { navigation: state.navigation.slice(0, -1), status: 'idle' });
        case ActionTypes.STATUS_UPDATED:
            return Object.assign(Object.assign({}, state), { status: action.payload });
        case ActionTypes.SEARCH_LOADED:
            return Object.assign(Object.assign({}, state), { status: 'idle', navigation: [], search: {
                    term: action.payload.term,
                    assets: action.payload.assets,
                } });
        case ActionTypes.GROUP_LOADED:
            return Object.assign(Object.assign({}, state), { groups: action.payload });
        default:
            return state;
    }
}
exports.workspaceReducer = workspaceReducer;
//# sourceMappingURL=workspace.store.js.map